// extracted by mini-css-extract-plugin
export default {"navigationGroupEmptySpace":"AppNav__navigationGroupEmptySpace___xaHIz","activeTriangle":"AppNav__activeTriangle___GGLTK","adminBar":"AppNav__adminBar___UiX8c"};